<script setup lang="ts">
    import DataTableActions from '@/components/datatable/DataTableActions.vue';
    import { TaskTemplate } from '@/types';
    import { usePermissions } from '@/composables/usePermissions';
    import EditTaskTemplate from './EditTaskTemplate.vue';
    import Delete from '@/components/Delete.vue';
    import Permission from '@/enums/Permission';
    import QueryKey from '@/enums/QueryKey';

    interface Props {
        taskTemplate: TaskTemplate;
    }

    defineProps<Props>();

    const { hasPermission } = usePermissions();
</script>

<template>
    <DataTableActions :data="taskTemplate">
        <EditTaskTemplate
            v-if="hasPermission(Permission.TASK_TEMPLATES_UPDATE)"
            :task-template="taskTemplate"
        />
        <Delete
            v-if="hasPermission(Permission.TASK_TEMPLATES_DELETE)"
            :route="route('v2.task-templates.destroy', taskTemplate.id)"
            :query-key="[QueryKey.TASK_TEMPLATES]"
            header="task-templates.delete.title"
            description="task-templates.delete.content"
        />
    </DataTableActions>
</template>
